import {
  addDoc,
  collection,
  getDoc,
  getDocs,
  doc,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { fireStore } from "../firebase";
import { uuid } from "utils/uuid";
import { scoreResume } from "utils/resumeMatcher";

export const JOB_POSTINGS = "jobPostings";
export const APPLICATIONS = "career";
export const GENERAL_JOB_ID = "general";

export const APPLICATION_STATUSES = [
  { value: "new", label: "New" },
  { value: "shortlisted", label: "Shortlisted" },
  { value: "interview", label: "Interview" },
  { value: "offered", label: "Offered" },
  { value: "hired", label: "Hired" },
  { value: "rejected", label: "Rejected" },
];

const withId = (snap) => ({ id: snap.id, ...snap.data() });
const byNewest = (a, b) => (b.createdAt || "").localeCompare(a.createdAt || "");

export const fetchActivePostings = async () => {
  const snap = await getDocs(
    query(collection(fireStore, JOB_POSTINGS), where("isActive", "==", true))
  );
  return snap.docs.map(withId).sort(byNewest);
};

export const fetchPosting = async (id) => {
  const snap = await getDoc(doc(fireStore, JOB_POSTINGS, id));
  return snap.exists() ? withId(snap) : null;
};

// Maps a jobPostings document to the shape the resume matcher expects.
export const toMatchJob = (posting) =>
  posting && {
    id: posting.id,
    title: posting.jobTitle,
    description: [posting.jobDescription, ...(posting.requirements || [])].join(" "),
    responsibilities: posting.responsibilities || [],
    requiredSkills: posting.skills || [],
    niceToHaveSkills: posting.niceToHaveSkills || [],
    minExperience: Number(posting.experienceLevel) || 0,
  };

export const scoreAgainstPosting = (resumeText, posting, declaredYears) =>
  scoreResume(resumeText, toMatchJob(posting), declaredYears);

export const postingLocation = (posting) =>
  [posting.location, posting.city].filter(Boolean).join(" · ");

export const uploadResume = async (file, jobId) => {
  const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, "_");
  const path = `resumes/${jobId}/${uuid()}-${safeName}`;
  const snapshot = await uploadBytes(ref(getStorage(), path), file);
  return { url: await getDownloadURL(snapshot.ref), path };
};

export const submitApplication = async (application) => {
  const now = new Date().toISOString();
  const docRef = await addDoc(collection(fireStore, APPLICATIONS), {
    ...application,
    status: "new",
    createdAt: now,
    updatedAt: now,
  });
  return docRef.id;
};

export const updateApplication = (id, data) =>
  updateDoc(doc(fireStore, APPLICATIONS, id), {
    ...data,
    updatedAt: new Date().toISOString(),
  });
